/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Goles por tramo de tiempo.
 */
export interface TimeIntervalGoalsDTO { 
    interval_label: string;
    goals_for: number;
    goals_against: number;
}

